import { render, staticRenderFns } from "./SingleText.vue?vue&type=template&id=fcc89598&scoped=true&"
import script from "./SingleText.vue?vue&type=script&lang=ts&"
export * from "./SingleText.vue?vue&type=script&lang=ts&"
import style0 from "./SingleText.vue?vue&type=style&index=0&id=fcc89598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc89598",
  null
  
)

export default component.exports